<template>
  <div v-if="hasCarousel" class="trick-carousel px-3 pt-3 mb-3">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <strong>{{ title }}</strong>
      <div class="btn-group btn-group-sm" role="group">
        <button class="btn btn-outline-secondary" type="button" @click.stop="$emit('prev')">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        <button class="btn btn-outline-secondary" type="button" @click.stop="$emit('next')">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <div class="carousel-track" :class="{ 'is-mobile': isMobile }">
      <div
        v-for="item in items"
        :key="item.id || item.trick?.id"
        class="carousel-item-thumb"
        :style="itemStyle"
        @click.stop="$emit('select-trick', item.trick || item)"
      >
        <div class="thumb-image-wrapper">
          <img :src="item.thumbnail || fallbackImage" class="img-fluid" :alt="item.name || item.trick?.name || 'Video'" />
        </div>
        <div class="thumb-title text-truncate" :title="item.name || item.trick?.name">{{ item.name || item.trick?.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrickVideoCarousel',
  props: {
    hasCarousel: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Ultimos videos publicados',
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemStyle: {
      type: Object,
      default: () => ({}),
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    fallbackImage: {
      type: String,
      default: '',
    },
  },
  emits: ['prev', 'next', 'select-trick'],
};
</script>

<style scoped>
.trick-carousel {
  background-color: #f8f9fa;
}

.carousel-track {
  display: flex;
  gap: 10px;
  overflow: hidden;
}

.carousel-item-thumb {
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 6px;
  background: #fff;
  transition: transform 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.carousel-item-thumb:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.thumb-image-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  overflow: hidden;
  border-radius: 4px;
  background: #000;
}

.thumb-image-wrapper img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumb-title {
  font-size: 0.85rem;
  margin-top: 4px;
}
</style>